<template>
  <button
    :type="type"
    class="al-btn al-btn--primary-dark w-full sm:w-auto focus:outline-none relative"
    :disabled="disabled"
    :class="{'opacity-50 pointer-events-none': disabled || isLoading, 'opacity-100': !disabled && !isLoading}"
  >
    <slot />
    <div
      v-if="isLoading"
      class="flex items-center justify-center ml-4 absolute -translate-y-1/2 right-[24px]"
    >
      <div class="w-3 h-3 loader rounded-full animate-spin" />
    </div>
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'submit',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loader{
  border-bottom: solid 2px #fff;
}
.right-\[24px\] {
  right: 24px;
}
</style>
